export default {
  backgroundHighlightColor: '--medkit-stepper-bg-highlight-color',
  textHighlightColor: '--medkit-stepper-text-highlight-color',
  iconFillColor: '--medkit-stepper-icon-fill-color',
  baseColor: '--medkit-stepper-base',
}
